// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V3PunctuationStates$LiteracyplanetTupperware from "./V3PunctuationStates.res.mjs";
import * as V3DndPunctuationBehaviour$LiteracyplanetTupperware from "./V3DndPunctuationBehaviour.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

function PilotPunctuation$PunctuationMarkStyle(props) {
  var __markedType = props.markedType;
  var markedType = __markedType !== undefined ? Caml_option.valFromOption(__markedType) : undefined;
  var tmp;
  if (markedType !== undefined) {
    switch (markedType) {
      case "Correct" :
          tmp = React.createElement("div", {
                className: "pilot-punctuation-tick-container"
              }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                    className: "pilot-punctuation-tick-svg"
                  }));
          break;
      case "Wrong" :
          tmp = React.createElement("div", {
                className: "pilot-punctuation-cross-container"
              }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                    className: "pilot-punctuation-cross-svg"
                  }));
          break;
      case "Unanswered" :
          tmp = React.createElement("div", {
                className: "pilot-punctuation-unanswered-container"
              });
          break;
      
    }
  } else {
    tmp = React.createElement("div", {
          className: "pilot-punctuation-unanswered-container"
        });
  }
  return React.createElement("div", {
              className: TailwindMerge.twMerge(props.placed ? "pilot-punctuation-markContainer" : "pilot-punctuation-markContainerPlaced", Belt_Option.getWithDefault(props.className, ""))
            }, React.createElement("div", {
                  className: "pilot-punctuation-handle"
                }, tmp), React.createElement("div", {
                  className: "pilot-punctuation-mark"
                }, props.children));
}

var PunctuationMarkStyle = {
  make: PilotPunctuation$PunctuationMarkStyle
};

function PilotPunctuation$MarkedPunctuationMark(props) {
  var children = props.children;
  var placed = props.placed;
  var match = Curry._1(V3PunctuationStates$LiteracyplanetTupperware.use, undefined);
  var answerVisible = match.answerVisible;
  if (answerVisible !== undefined && answerVisible) {
    return React.createElement(PilotPunctuation$PunctuationMarkStyle, {
                className: "punctuationCorrect",
                placed: placed,
                markedType: "Correct",
                children: children
              });
  }
  var markedType = Curry._1(match.getResponseMarkType, props.id);
  switch (markedType) {
    case "Correct" :
        return React.createElement(PilotPunctuation$PunctuationMarkStyle, {
                    className: "punctuationCorrect",
                    placed: placed,
                    markedType: Caml_option.some(markedType),
                    children: children
                  });
    case "Wrong" :
        return React.createElement(PilotPunctuation$PunctuationMarkStyle, {
                    className: "punctuationIncorrect",
                    placed: placed,
                    markedType: Caml_option.some(markedType),
                    children: children
                  });
    case "Unanswered" :
        return React.createElement(PilotPunctuation$PunctuationMarkStyle, {
                    className: "punctuationUnanswered",
                    placed: placed,
                    markedType: Caml_option.some(markedType),
                    children: children
                  });
    
  }
}

var MarkedPunctuationMark = {
  make: PilotPunctuation$MarkedPunctuationMark
};

function PilotPunctuation$PunctuationMark(props) {
  var __isMarked = props.isMarked;
  var __placed = props.placed;
  var text = props.text;
  var id = props.id;
  var placed = __placed !== undefined ? __placed : false;
  var isMarked = __isMarked !== undefined ? __isMarked : false;
  if (isMarked) {
    return React.createElement(PilotPunctuation$MarkedPunctuationMark, {
                id: id,
                placed: placed,
                children: text
              });
  } else {
    return React.createElement(V3DndPunctuationBehaviour$LiteracyplanetTupperware.DraggablePunctuation.make, {
                id: id,
                className: "inline-block",
                children: React.createElement(PilotPunctuation$PunctuationMarkStyle, {
                      placed: placed,
                      children: text
                    })
              });
  }
}

var PunctuationMark = {
  make: PilotPunctuation$PunctuationMark
};

function PilotPunctuation$Characters(props) {
  var match = Curry._1(V3PunctuationStates$LiteracyplanetTupperware.use, undefined);
  var isMarked = match.isMarked;
  var match$1 = Curry._1(V3DndPunctuationBehaviour$LiteracyplanetTupperware.DndApi.use, undefined);
  var groups = Belt_Array.reduce(match$1.characters, [[]], (function (wordGroups, $$char) {
          if ($$char.text === "\u00A0") {
            return Belt_Array.concatMany([
                        wordGroups,
                        [[$$char]]
                      ]);
          }
          var lastIndex = wordGroups.length - 1 | 0;
          return Belt_Array.mapWithIndex(wordGroups, (function (i, arr) {
                        if (i === lastIndex) {
                          return Belt_Array.concatMany([
                                      arr,
                                      [$$char]
                                    ]);
                        } else {
                          return arr;
                        }
                      }));
        }));
  return Belt_Array.map(groups, (function (words) {
                return React.createElement("div", {
                            className: "pilot-punctuation-word"
                          }, Belt_Array.map(words, (function (param) {
                                  var text = param.text;
                                  var id = param.id;
                                  var tmp = param.kind;
                                  if (typeof tmp === "object") {
                                    return JsxPPXReactSupportC.createElementWithKey(id, PilotPunctuation$PunctuationMark, {
                                                id: id,
                                                text: text,
                                                placed: true,
                                                isMarked: isMarked
                                              });
                                  }
                                  switch (tmp) {
                                    case "Character" :
                                        return JsxPPXReactSupportC.createElementWithKey(id, V3DndPunctuationBehaviour$LiteracyplanetTupperware.SortCharacters.make, {
                                                    id: id,
                                                    className: "pilot-punctuation-characters",
                                                    children: text
                                                  });
                                    case "CharacterEnd" :
                                        return React.createElement("div", {
                                                    key: "charsend",
                                                    className: "pilot-punctuation-endslot"
                                                  });
                                    case "PunctuationEnd" :
                                        return React.createElement("div", {
                                                    key: "punctend"
                                                  });
                                    
                                  }
                                })));
              }));
}

var Characters = {
  make: PilotPunctuation$Characters
};

function PilotPunctuation$Punctuation(props) {
  var match = Curry._1(V3DndPunctuationBehaviour$LiteracyplanetTupperware.DndApi.use, undefined);
  var match$1 = Curry._1(V3PunctuationStates$LiteracyplanetTupperware.use, undefined);
  var isMarked = match$1.isMarked;
  return React.createElement(React.Fragment, {}, Belt_Array.map(match.punctuation, (function (param) {
                    var id = param.id;
                    return JsxPPXReactSupportC.createElementWithKey(id, PilotPunctuation$PunctuationMark, {
                                id: id,
                                text: param.text,
                                isMarked: isMarked
                              });
                  })), React.createElement(V3DndPunctuationBehaviour$LiteracyplanetTupperware.DragOverlay.make, {
                  render: (function (t) {
                      if (t !== undefined) {
                        return React.createElement(PilotPunctuation$PunctuationMark, {
                                    id: t.id,
                                    text: t.text
                                  });
                      } else {
                        return null;
                      }
                    })
                }));
}

var Punctuation = {
  make: PilotPunctuation$Punctuation
};

function PilotPunctuation$StateSync(props) {
  var questionIndex = props.questionIndex;
  var id = props.id;
  var match = Curry._1(V3DndPunctuationBehaviour$LiteracyplanetTupperware.DndApi.use, undefined);
  var setItems = match.setItems;
  var items = match.items;
  var match$1 = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match$1[1];
  var match$2 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var getCorrectAnswer = match$2.getCorrectAnswer;
  var getStep = match$2.getStep;
  React.useEffect((function (param) {
          var correctAnswer = Curry._1(getCorrectAnswer, questionIndex);
          if (correctAnswer !== undefined) {
            V3PunctuationStates$LiteracyplanetTupperware.onSetQuestionState(id, questionIndex, dispatch, Curry._1(getStep, questionIndex), correctAnswer, items);
          }
          
        }), [items]);
  var match$3 = Curry._1(V3PunctuationStates$LiteracyplanetTupperware.use, undefined);
  var showAnswer = match$3.showAnswer;
  var backupItems = React.useRef([]);
  React.useEffect((function (param) {
          if (typeof showAnswer !== "object") {
            if (showAnswer !== "NotInitialised") {
              Curry._1(setItems, (function (param) {
                      return backupItems.current;
                    }));
            }
            
          } else {
            var correctAnswerItems = showAnswer._0;
            backupItems.current = items;
            Curry._1(setItems, (function (param) {
                    return correctAnswerItems;
                  }));
          }
        }), [showAnswer]);
  return props.children;
}

var StateSync = {
  make: PilotPunctuation$StateSync
};

function PilotPunctuation(props) {
  var questionIndex = props.questionIndex;
  var items = props.items;
  var id = props.id;
  return React.createElement(V3PunctuationStates$LiteracyplanetTupperware.Api.make, {
              items: items,
              questionIndex: questionIndex,
              children: React.createElement(V3DndPunctuationBehaviour$LiteracyplanetTupperware.DndProvider.make, {
                    children: React.createElement("div", {
                          className: "pilot-punctuation-container"
                        }, React.createElement(V3DndPunctuationBehaviour$LiteracyplanetTupperware.SortContext.make, {
                              id: id,
                              items: items,
                              children: React.createElement(PilotPunctuation$StateSync, {
                                    id: id,
                                    questionIndex: questionIndex,
                                    children: null
                                  }, React.createElement("div", {
                                        className: "pilot-punctuation-charsParentContainer"
                                      }, React.createElement(PilotPunctuation$Characters, {})), React.createElement("div", {
                                        className: "pilot-punctuation-marksParentContainer"
                                      }, React.createElement(PilotPunctuation$Punctuation, {})))
                            }))
                  })
            });
}

var make = PilotPunctuation;

export {
  PunctuationMarkStyle ,
  MarkedPunctuationMark ,
  PunctuationMark ,
  Characters ,
  Punctuation ,
  StateSync ,
  make ,
}
/* react Not a pure module */
